import { render, staticRenderFns } from "./Game4-14.vue?vue&type=template&id=67989788&scoped=true&"
import script from "./Game4-14.vue?vue&type=script&lang=js&"
export * from "./Game4-14.vue?vue&type=script&lang=js&"
import style0 from "./Game4-14.vue?vue&type=style&index=0&id=67989788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67989788",
  null
  
)

export default component.exports